import script from "./LessExpense.vue?vue&type=script&setup=true&lang=js"
export * from "./LessExpense.vue?vue&type=script&setup=true&lang=js"

import "./LessExpense.vue?vue&type=style&index=0&id=c9483eb4&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9483eb4"]])

export default __exports__